import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

import css from './MenuCategoryComponent.module.css';
import {menuCategoriesService} from "../../../services/settings-services";
import {menuCategoriesActions} from "../../../store/slices/settings-slices";
import {ButtonDelete, ButtonUpdate, ModalForDelete} from "../../../ui";
import {
    MenuCategoriesUpdateCategoryModal
} from "../settingSectionModals/MenuCategoriesUpdateCategoryModal/MenuCategoriesUpdateCategoryModal";


const MenuCategoryComponent = (props) => {
    const dispatch = useDispatch();
    const {i18n} = useTranslation();
    const [isOpenUpdate, setIsOpenUpdate] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const {menuCategory: { id, name }} = props;


    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name["en"];

    const handleDeleteClick = async () => {
        try {
            await menuCategoriesService.deleteById(id);
            dispatch(menuCategoriesActions.changeTrigger());
            toast.success('category is deleting!');
        } catch (error) {
            console.error("Error deleting category:", error);
        }
    };

    const handleUpdateClick = () => {
        setIsOpenUpdate(true);
    };


    return (
        <section className={css.wrap}>
            <section className={css.title}>{displayName}</section>

            <section className={css.blockButton}>
                <ButtonUpdate onClick={handleUpdateClick}/>
                <ButtonDelete onClick={() => setIsOpenDeleteModal(true)}/>
            </section>

            {isOpenUpdate && <MenuCategoriesUpdateCategoryModal
                setIsOpenUpdate={setIsOpenUpdate}
                menuCategory={props.menuCategory}
            />}

            {isOpenDeleteModal && <ModalForDelete
                handleDeleteClick={handleDeleteClick}
                setIsOpenDeleteModal={setIsOpenDeleteModal}
                name={'category'}
            />}
        </section>
    );
};

export default React.memo(MenuCategoryComponent);